/* ============
 * Actions for the profile module
 * ============
 *
 * The actions that are available on the
 * profile module.
 */
import Vue from 'vue';
import GroupProxy from '@/proxies/GroupProxy';
import GroupUsersProxy from '@/proxies/GroupUserProxy';
// import message from '@/constants/_message';
import types from './mutation-types';

export const viewAll = ({ commit }, data) => {

  commit(types.FETCH_ALL_GROUPS);
  new GroupProxy().viewAll(data)
    .then((response) => {
      commit(types.FETCH_ALL_GROUPS_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_ALL_GROUPS_FAIL, error);
    });
};

export const upsert = ({ commit }, data) => {
  commit(types.CREATE_GROUP);
  new GroupProxy().upsert(data)
    .then((response) => {
      commit(types.CREATE_GROUP_SUCCESS, response.group);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: 'Group created',
        type: 'success'
      });
    }).catch(({ error }) => {
      commit(types.CREATE_GROUP_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: error.message || 'Create Group failed',
        type: 'error'
      });
    });
};

export const editStart = ({ commit }, id) => {
  // eslint-disable-next-line 
  console.log('action -> EDIT_START');

  commit(types.EDIT_START, id);
};

export const editCancel = ({ commit }, id) => {
  // eslint-disable-next-line 
  console.log('action -> EDIT_CANCEL');

  commit(types.EDIT_CANCEL, id);
};

export const saveGroup = ({ commit }, shadowCopy) => {
  // eslint-disable-next-line 
  console.log('action -> EDIT_SAVE shadowCopy', shadowCopy);

  new GroupProxy().upsert(shadowCopy)
    .then((response) => {

      // eslint-disable-next-line 
      console.log('action -> EDIT_SAVE then. response', response);

      commit(types.EDIT_SAVE_SUCCESS, response.group);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: 'Group updated',
        type: 'success'
      });
    }).catch(({ error }) => {
      commit(types.EDIT_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: error.message || 'Roal edit failed',
        type: 'error'
      });
    });
};

// getGroupUserList,
const getGroupUserList = ({ commit }, data) => {
  // eslint-disable-next-line 
  console.log('action -> getGroupUserList in', data);

  commit(types.FETCH_GROUP_USERS);

  new GroupUsersProxy().getGroupUserList(data)
    .then((response) => {
      commit(types.FETCH_GROUP_USERS_SUCCESS, { response, requestData: data });
    }).catch((error) => {
      commit(types.FETCH_GROUP_USERS_FAIL, error);
    });
};

export const assignGroupPatient = ({ commit }, data) => {
  commit(types.ASSIGN_UNASSIGN_GROUP_PATIENT_BEGIN, data);

  new GroupUsersProxy().assignUnassignMany(data)
    .then(() => {
      commit(types.ASSIGN_GROUP_PATIENT, data);
    }).catch((error) => {
      commit(types.ASSIGN_GROUP_PATIENT_FAIL, error, data);
    });
};

export const unassignGroupPatient = ({ commit }, data) => {
  commit(types.ASSIGN_UNASSIGN_GROUP_PATIENT_BEGIN, data);

  new GroupUsersProxy().assignUnassignMany(data)
    .then(() => {
      commit(types.UNASSIGN_GROUP_PATIENT, data);
    }).catch((error) => {
      commit(types.UNASSIGN_GROUP_PATIENT_FAIL, error, data);
    });
};

export const getGroupInfo = ({ commit }, groupId) => {

  commit(types.FETCH_GROUP_INFO, null);
  new GroupProxy().getGroupInfo(groupId)
    .then((response) => {
      commit(types.FETCH_GROUP_INFO_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_GROUP_INFO_FAIL, error);
    });
};

export const clearState = ({ commit }) => {
  commit(types.CLEAR_STATE, null);
};

// selectAllItems
export const selectAllItems = ({ commit }, selectAll) => {
  commit(types.GROUP_USER_SELECT_ITEMS, selectAll);
};

// selectOneItems
export const selectOneItems = ({ commit }, gp) => {
  commit(types.GROUP_USERS_SELECT_ONE_ITEM, gp);
};
//assignUnassignMany
export const assignUnassignMany = ({ commit }, data) => {

  if (data.users.length <= 0) {
    return;
  }
  // eslint-disable-next-line 
  console.log('action -> assignUnassignMany 1');
  commit(types.GROUP_USER_ASSIGN_UNASSIGN_ALL_START, data);

  // eslint-disable-next-line 
  console.log('action -> assignUnassignMany 2');

  new GroupUsersProxy().assignUnassignMany(data)
    .then((response) => {
      commit(types.GROUP_USER_ASSIGN_UNASSIGN_ALL_SUCCESS, { data, response });
    }).catch((error) => {
      commit(types.GROUP_USER_ASSIGN_UNASSIGN_ALL_FAIL, error);
    });
};

export default {
  upsert,
  viewAll,
  editStart,
  editCancel,
  saveGroup,
  getGroupUserList,
  assignGroupPatient,
  unassignGroupPatient,
  getGroupInfo,
  clearState,
  selectAllItems,
  selectOneItems,
  assignUnassignMany,
};
